<template>
  <div class="font-sans antialiased" dir="rtl">
    <div id="root">
      <!-- Hero Section -->
      <section
        class="relative min-h-screen flex items-center overflow-hidden pt-20"
        style="padding: 20px"
      >
        <div class="absolute inset-0 overflow-hidden pointer-events-none">
          <!-- دایره‌های گرادینتی -->
          <div
            class="absolute top-20 -right-32 w-96 h-96 rounded-full opacity-20 blur-3xl animate-float-slow bg-gradient-to-br from-[#eb4763] to-[#a347d1]"
          ></div>
          <div
            class="absolute bottom-20 -left-32 w-96 h-96 rounded-full opacity-20 blur-3xl animate-float-slow animation-delay-2000 bg-gradient-to-tl from-[#2eb8aa] to-[#eb4763]"
          ></div>
          <div
            class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full opacity-10 blur-3xl animate-pulse-slow bg-gradient-to-r from-[#eb4763] via-[#a347d1] to-[#2eb8aa]"
          ></div>

          <!-- خطوط گرادینتی اضافه -->
          <div
            class="absolute top-40 right-20 w-64 h-[2px] rotate-45 bg-gradient-to-r from-transparent via-[#eb4763] to-transparent blur-[2px] animate-pulse-slow"
          ></div>
          <div
            class="absolute bottom-40 left-20 w-64 h-[2px] -rotate-45 bg-gradient-to-r from-transparent via-[#2eb8aa] to-transparent blur-[2px] animate-pulse-slow animation-delay-2000"
          ></div>
        </div>

        <div class="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div class="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <!-- محتوای سمت راست -->
            <div class="text-center lg:text-right animate-fade-in-right">
              <div
                class="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-[#eb4763]/10 to-[#a347d1]/10 border border-[#eb4763]/20 text-sm font-medium text-foreground mb-6 animate-fade-in-right backdrop-blur-sm"
              >
                <span
                  class="w-2 h-2 rounded-full animate-pulse-soft bg-gradient-to-r from-[#2eb8aa] to-[#eb4763]"
                ></span>
                مورد اعتماد ۲۳,۰۰۰+ فروشگاه فعال
              </div>

              <h1
                class="text-2xl sm:text-4xl lg:text-4xl font-extrabold leading-tight mb-6 animate-fade-in-right animation-delay-300"
                style="line-height: 50px"
              >
                <span
                  class="bg-gradient-to-r from-[#eb4763] via-[#a347d1] to-[#2eb8aa] bg-clip-text text-transparent animate-gradient-x bg-[length:200%_auto]"
                  >فروشگاه آنلاین</span
                >
                خود را در چند دقیقه بسازید
              </h1>

              <p
                style="font-weight: 300"
                class="text-lg sm:text-xl text-muted-foreground max-w-xl mx-auto lg:mx-0 mb-8 leading-relaxed animate-fade-in-right animation-delay-500"
              >
                پلتفرم بدون کدنویسی با امکانات قدرتمند برای راه‌اندازی، مدیریت و
                رشد کسب‌وکار اینترنتی. امروز فروش خود را شروع کنید.
              </p>

              <div
                class="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start mb-12 animate-fade-in-right animation-delay-700"
              >
                <a
                  href="https://panel.shopecom.ir/"
                  class="group relative inline-flex items-center gap-2 px-8 py-4 rounded-2xl text-base font-bold text-white transition-all duration-300 hover:scale-110 overflow-hidden"
                  style="background: linear-gradient(135deg, #eb4763, #a347d1)"
                >
                  <span
                    class="absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000"
                  ></span>
                  <span class="relative">شروع رایگان</span>
                  <ArrowLeft
                    :size="18"
                    class="transition-all group-hover:-translate-x-2 group-hover:scale-110 relative"
                  />
                </a>

                <A href="https://alidadashop.ir"
                  class="inline-flex items-center gap-2 px-8 py-4 rounded-2xl text-base font-semibold border-2 border-transparent bg-gradient-to-r from-[#eb4763]/10 to-[#a347d1]/10 text-foreground hover:from-[#eb4763]/20 hover:to-[#a347d1]/20 transition-all duration-300 hover:scale-110 group relative overflow-hidden backdrop-blur-sm"
                >
                  <span
                    class="absolute inset-0 bg-gradient-to-l from-primary/0 via-primary/10 to-primary/0 translate-x-full group-hover:-translate-x-full transition-transform duration-1000"
                  ></span>
                  <Play
                    :size="18"
                    class="text-transparent bg-gradient-to-r from-[#eb4763] to-[#a347d1] bg-clip-text animate-pulse-soft"
                  />
                  <span
                    class="bg-gradient-to-r from-[#eb4763] to-[#a347d1] bg-clip-text text-transparent"
                    >مشاهده دمو</span
                  >
              </A>
              </div>
            </div>

            <div class="relative">
              <div class="relative rounded-3xl overflow-hidden group">
                <div
                  class="absolute -inset-1 bg-gradient-to-r from-[#eb4763] via-[#a347d1] to-[#2eb8aa] rounded-3xl opacity-75 blur-xl group-hover:blur-2xl transition-all duration-700 animate-gradient-x bg-[length:200%_auto]"
                ></div>
                <div
                  class="absolute -inset-1 bg-gradient-to-l from-[#eb4763] via-[#a347d1] to-[#2eb8aa] rounded-3xl opacity-0 group-hover:opacity-50 blur-md transition-all duration-1000 animate-gradient-x bg-[length:200%_auto] animation-delay-2000"
                ></div>
                <div
                  class="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none overflow-hidden"
                >
                  <div
                    class="absolute -inset-1 bg-gradient-to-r from-[#eb4763]/20 via-transparent to-[#2eb8aa]/20 blur-xl animate-shimmer-wave"
                  ></div>
                  <div
                    class="absolute top-0 -left-20 w-40 h-40 rounded-full blur-3xl animate-pulse-slow bg-gradient-to-r from-[#eb4763]/20 to-[#a347d1]/20"
                  ></div>
                  <div
                    class="absolute bottom-0 -right-20 w-40 h-40 rounded-full blur-3xl animate-pulse-slow animation-delay-1000 bg-gradient-to-r from-[#2eb8aa]/20 to-[#eb4763]/20"
                  ></div>
                </div>
                <div style="padding: 10px">
                  <div
                    style="background-color: white"
                    class="relative bg-card/90 rounded-[22px] p-6 sm:p-6 shadow-card border border-white/10 bg-white-900"
                  >
                    <div class="flex items-center gap-2 mb-6">
                      <div
                        class="w-3 h-3 rounded-full animate-pulse-soft bg-gradient-to-br from-[#eb4763] to-[#eb4763]/80"
                      ></div>
                      <div
                        class="w-3 h-3 rounded-full animate-pulse-soft animation-delay-300 bg-gradient-to-br from-[#f9c31f] to-[#f9c31f]/80"
                      ></div>
                      <div
                        class="w-3 h-3 rounded-full animate-pulse-soft animation-delay-600 bg-gradient-to-br from-[#33cc66] to-[#33cc66]/80"
                      ></div>
                      <div
                        class="flex-1 h-6 bg-gradient-to-r from-muted to-muted/50 rounded-lg mr-4 relative overflow-hidden from-[#2eb8aa]/20 to-[#eb4763]/20"
                        style="border: 1px"
                      >
                        <div
                          class="absolute inset-0 bg-gradient-to-r from-transparent via-[#eb4763]/20 to-transparent translate-x-full animate-shimmer"
                        ></div>
                      </div>
                    </div>

                    <div class="grid grid-cols-3 gap-3 mb-6">
                      <div
                        class="bg-gradient-to-br from-muted to-muted/80 rounded-xl p-3 hover:scale-105 transition-transform duration-300 relative overflow-hidden group/card border border-white/5 glass"
                      >
                        <div
                          class="absolute inset-0 opacity-0 group-hover/card:opacity-100 transition-opacity duration-500 bg-gradient-to- from-[#2eb8aa]/20 to-[#eb4763]/20"
                        >
                          <div
                            class="absolute inset-0 bg-gradient-to-r from-transparent via-[#eb4763]/10 to-transparent -skew-x-12 animate-shimmer"
                          ></div>
                        </div>
                        <div class="text-xs text-muted-foreground mb-1">
                          درآمد
                        </div>
                        <div class="text-lg font-bold text-foreground">
                          ۱۲,۴۵۰ تومان
                        </div>
                        <div
                          class="mt-2 h-1.5 rounded-full bg-border/50 overflow-hidden"
                        >
                          <div
                            class="h-full rounded-full w-3/4 animate-grow-width bg-gradient-to-r from-[#eb4763] to-[#eb4763]/80"
                          ></div>
                        </div>
                      </div>

                      <div
                        class="bg-gradient-to-br from-muted to-muted/80 rounded-xl p-3 hover:scale-105 transition-transform duration-300 relative overflow-hidden group/card border border-white/5 glass"
                      >
                        <div
                          class="absolute inset-0 opacity-0 group-hover/card:opacity-100 transition-opacity duration-500 bg-gradient-to- from-[#2eb8aa]/20 to-[#eb4763]/20"
                        >
                          <div
                            class="absolute inset-0 bg-gradient-to-r from-transparent via-[#2eb8aa]/10 to-transparent -skew-x-12 animate-shimmer"
                          ></div>
                        </div>
                        <div class="text-xs text-muted-foreground mb-1">
                          سفارشات
                        </div>
                        <div class="text-lg font-bold text-foreground">۳۸۴</div>
                        <div
                          class="mt-2 h-1.5 rounded-full bg-border/50 overflow-hidden"
                        >
                          <div
                            class="h-full rounded-full w-3/4 animate-grow-width animation-delay-200 bg-gradient-to-r from-[#2eb8aa] to-[#2eb8aa]/80"
                          ></div>
                        </div>
                      </div>

                      <div
                        class="bg-gradient-to-br from-muted to-muted/80 rounded-xl p-3 hover:scale-105 transition-transform duration-300 relative overflow-hidden group/card border border-white/5 glass"
                      >
                        <div
                          class="absolute inset-0 opacity-0 group-hover/card:opacity-100 transition-opacity duration-500 bg-gradient-to from-[#2eb8aa]/20 to-[#eb4763]/20"
                        >
                          <div
                            class="absolute inset-0 bg-gradient-to-r from-transparent via-[#a347d1]/10 to-transparent -skew-x-12 animate-shimmer"
                          ></div>
                        </div>
                        <div class="text-xs text-muted-foreground mb-1">
                          بازدیدکنندگان
                        </div>
                        <div class="text-lg font-bold text-foreground">
                          ۸,۲۹۱
                        </div>
                        <div
                          class="mt-2 h-1.5 rounded-full bg-border/50 overflow-hidden"
                        >
                          <div
                            class="h-full rounded-full w-3/4 animate-grow-width animation-delay-400 bg-gradient-to-r from-[#a347d1] to-[#a347d1]/80"
                          ></div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="bg-gradient-to-br from-muted to-muted/80 rounded-xl p-4 border border-white/5 glass"
                    >
                      <div class="flex items-end gap-1.5 h-24">
                        <div
                          class="flex-1 rounded-t-md animate-grow-height bg-gradient-to-t from-[#eb4763]/30 to-[#eb4763]/10"
                          style="height: 40%"
                        ></div>
                        <div
                          class="flex-1 rounded-t-md animate-grow-height animation-delay-100 bg-gradient-to-t from-[#2eb8aa]/30 to-[#2eb8aa]/10"
                          style="height: 65%"
                        ></div>
                        <div
                          class="flex-1 rounded-t-md animate-grow-height animation-delay-200 bg-gradient-to-t from-[#a347d1]/30 to-[#a347d1]/10"
                          style="height: 45%"
                        ></div>
                        <div
                          class="flex-1 rounded-t-md animate-grow-height animation-delay-300 bg-gradient-to-t from-[#eb4763]/30 to-[#eb4763]/10"
                          style="height: 80%"
                        ></div>
                        <div
                          class="flex-1 rounded-t-md animate-grow-height animation-delay-400 bg-gradient-to-t from-[#2eb8aa]/30 to-[#2eb8aa]/10"
                          style="height: 55%"
                        ></div>
                        <div
                          class="flex-1 rounded-t-md animate-grow-height animation-delay-500 bg-gradient-to-t from-[#a347d1]/30 to-[#a347d1]/10"
                          style="height: 90%"
                        ></div>
                        <div
                          class="flex-1 rounded-t-md animate-grow-height animation-delay-600 bg-gradient-to-t from-[#eb4763]/30 to-[#eb4763]/10"
                          style="height: 70%"
                        ></div>
                        <div
                          class="flex-1 rounded-t-md animate-grow-height animation-delay-700 bg-gradient-to-t from-[#2eb8aa]/30 to-[#2eb8aa]/10"
                          style="height: 85%"
                        ></div>
                        <div
                          class="flex-1 rounded-t-md animate-grow-height animation-delay-800 bg-gradient-to-t from-[#a347d1]/30 to-[#a347d1]/10"
                          style="height: 60%"
                        ></div>
                        <div
                          class="flex-1 rounded-t-md animate-grow-height animation-delay-900 bg-gradient-to-t from-[#eb4763] to-[#a347d1]"
                          style="height: 95%"
                        ></div>
                        <div
                          class="flex-1 rounded-t-md animate-grow-height animation-delay-1000 bg-gradient-to-t from-[#a347d1] to-[#2eb8aa]"
                          style="height: 75%"
                        ></div>
                        <div
                          class="flex-1 rounded-t-md animate-grow-height animation-delay-1100 bg-gradient-to-t from-[#2eb8aa] to-[#eb4763]"
                          style="height: 88%"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="absolute -bottom-4 -right-4 glass rounded-2xl px-4 py-3 shadow-card animate-float hover:scale-110 transition-transform duration-300 z-20 bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-md border border-white/20"
              >
                <div class="flex items-center gap-2">
                  <div
                    class="w-8 h-8 rounded-lg flex items-center justify-center text-white bg-gradient-to-br from-[#eb4763] to-[#a347d1]"
                  >
                    <Zap :size="16" />
                  </div>
                  <div>
                    <div class="text-xs text-muted-foreground">سفارش جدید</div>
                    <div
                      class="text-sm font-bold text-transparent bg-gradient-to-r from-[#eb4763] to-[#a347d1] bg-clip-text"
                    >
                      +۲۴۹,۰۰۰ تومان
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        id="features"
        class="section-padding relative overflow-hidden"
        style="padding: 20px"
      >
        <div class="absolute inset-0 pointer-events-none overflow-hidden">
          <div
            class="absolute -left-20 top-20 w-40 h-40 bg-gradient-to-br from-primary/10 to-transparent rounded-3xl rotate-12 animate-float-slow opacity-30 blur-sm"
          ></div>
          <div
            class="absolute -right-20 bottom-20 w-56 h-56 bg-gradient-to-tl from-secondary/10 to-transparent rounded-3xl -rotate-12 animate-float-slow animation-delay-1000 opacity-30 blur-sm"
          ></div>
          <div
            class="absolute left-1/3 top-1/2 w-24 h-24 bg-gradient-to-tr from-primary/10 to-transparent rounded-full animate-pulse-slow opacity-20 blur-md"
          ></div>
        </div>

        <div class="container mx-auto relative z-10">
          <div class="text-center mb-16 animate-fade-in-up">
            <span
              class="inline-block px-4 py-1.5 rounded-full bg-muted text-xs font-semibold text-primary mb-4 tracking-wide uppercase animate-bounce-soft"
            >
              چرا شاپیکام
            </span>
            <h2
              class="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-foreground mb-4"
            >
              همه چیز برای
              <span class="gradient-text animate-gradient-x">موفقیت</span> شما
            </h2>
            <p
              class="text-muted-foreground text-lg max-w-2xl mx-auto animate-fade-in-up animation-delay-200"
            >
              ابزارها و امکانات قدرتمند طراحی شده برای کمک به رشد کسب‌وکار
              آنلاین شما از روز اول
            </p>
          </div>

          <div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <!-- کارت‌های Feature -->
            <div
              v-for="(feature, index) in features"
              :key="index"
              class="group relative bg-card rounded-2xl p-6 sm:p-8 shadow-card gradient-border cursor-pointer animate-fade-in-up hover:scale-105 transition-all duration-300 overflow-hidden"
              :style="{ animationDelay: `${index * 100}ms` }"
            >
              <!-- افکت هوور برای کارت -->
              <div
                class="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none"
              >
                <div
                  class="absolute -inset-1 bg-gradient-to-r from-primary/20 via-transparent to-secondary/20 blur-xl animate-shimmer-wave"
                ></div>
                <div
                  class="absolute top-0 -left-20 w-40 h-40 bg-primary/10 rounded-full blur-3xl animate-pulse-slow"
                ></div>
                <div
                  class="absolute bottom-0 -right-20 w-40 h-40 bg-secondary/10 rounded-full blur-3xl animate-pulse-slow animation-delay-1000"
                ></div>
              </div>

              <div
                class="w-12 h-12 rounded-xl flex items-center justify-center text-primary-foreground mb-5 transition-all duration-300 group-hover:scale-125 group-hover:rotate-6"
                :style="{ background: feature.gradient }"
              >
                <component :is="feature.icon" :size="22" />
              </div>
              <h3
                class="text-lg font-bold text-foreground mb-2 group-hover:text-primary transition-colors"
              >
                {{ feature.title }}
              </h3>
              <p class="text-sm text-muted-foreground leading-relaxed mb-4">
                {{ feature.description }}
              </p>
              <a
                href="#"
                class="inline-flex items-center gap-1 text-sm font-semibold text-primary hover:gap-2 transition-all group-hover:gap-3"
              >
                بیشتر بدانید
                <ArrowLeft
                  :size="14"
                  class="group-hover:-translate-x-1 transition-transform"
                />
              </a>
            </div>
          </div>
        </div>
      </section>

      <!-- بخش آمار زنده -->
      <section class="section-padding bg-muted/50" style="padding: 20px">
        <div class="container mx-auto">
          <div class="text-center mb-12 animate-fade-in-up">
            <span
              class="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-card text-xs font-semibold text-primary mb-4"
            >
              <Activity :size="12" class="animate-pulse-soft" />
              آمار زنده پلتفرم
            </span>
            <h2 class="text-3xl sm:text-4xl font-extrabold text-foreground">
              داشبورد
              <span class="gradient-text animate-gradient-x">لحظه‌ای</span>
            </h2>
          </div>

          <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
            <div
              v-for="(stat, index) in stats"
              :key="index"
              class="bg-card rounded-2xl p-5 shadow-card text-center animate-fade-in-up hover:scale-105 transition-all duration-300"
              :style="{ animationDelay: `${index * 100}ms` }"
            >
              <div
                class="w-10 h-10 mx-auto rounded-xl flex items-center justify-center text-primary-foreground mb-3 animate-bounce-soft"
                :style="{ background: stat.gradient }"
              >
                <component :is="stat.icon" :size="18" />
              </div>
              <div class="text-2xl font-bold text-foreground mb-1">
                {{ stat.value }}
              </div>
              <div class="text-xs text-muted-foreground font-medium">
                {{ stat.label }}
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- بخش Templates (تمپلیت‌های آماده) -->


      <!-- بخش Pricing با المان‌های نورپردازی - نسخه جدید و زیباتر -->
      <section
        id="pricing"
        class="section-padding relative overflow-hidden"
        style="padding: 20px"
      >
        <!-- المان‌های نورپردازی پیشرفته -->
        <div class="absolute inset-0 pointer-events-none">
          <!-- دایره‌های گرادینت در پس‌زمینه -->
          <div
            class="absolute top-40 -right-20 w-72 h-72 rounded-full opacity-20 blur-3xl animate-float-slow bg-gradient-to-br from-[#eb4763] to-[#a347d1]"
          ></div>
          <div
            class="absolute bottom-40 -left-20 w-80 h-80 rounded-full opacity-20 blur-3xl animate-float-slow animation-delay-2000 bg-gradient-to-tl from-[#2eb8aa] to-[#eb4763]"
          ></div>

          <!-- خطوط نورانی متحرک -->
          <div
            class="absolute top-1/3 right-10 w-40 h-[2px] rotate-45 bg-gradient-to-r from-transparent via-[#eb4763] to-transparent blur-sm animate-pulse-slow"
          ></div>
          <div
            class="absolute bottom-1/3 left-10 w-40 h-[2px] -rotate-45 bg-gradient-to-r from-transparent via-[#2eb8aa] to-transparent blur-sm animate-pulse-slow animation-delay-1000"
          ></div>

          <!-- ذرات نورانی رقصان -->
          <div
            v-for="i in 8"
            :key="i"
            class="absolute w-1 h-1 rounded-full"
            :style="{
              top: Math.random() * 100 + '%',
              left: Math.random() * 100 + '%',
              background: `linear-gradient(135deg, ${
                ['#eb4763', '#a347d1', '#2eb8aa'][i % 3]
              }, transparent)`,
              animation: `float-particle ${
                8 + Math.random() * 5
              }s ease-in-out infinite`,
              animationDelay: Math.random() * 3 + 's',
              opacity: 0.2,
            }"
          ></div>
        </div>

        <div class="container mx-auto relative z-10">
          <!-- هدر بخش -->
          <div class="text-center mb-16 animate-fade-in-up">
            <span
              class="inline-block px-4 py-1.5 rounded-full bg-gradient-to-r from-[#eb4763]/10 to-[#a347d1]/10 border border-[#eb4763]/20 text-xs font-semibold text-foreground mb-4 tracking-wide uppercase backdrop-blur-sm"
            >
              طرح‌های قیمت‌گذاری
            </span>
            <h2
              class="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-foreground mb-4"
            >
              طرح
              <span
                class="bg-gradient-to-r from-[#eb4763] via-[#a347d1] to-[#2eb8aa] bg-clip-text text-transparent animate-gradient-x bg-[length:200%_auto]"
                >مناسب</span
              >
              خود را انتخاب کنید
            </h2>
            <p
              class="text-muted-foreground text-lg max-w-2xl mx-auto mb-8 animate-fade-in-up animation-delay-200"
            >
              رایگان شروع کنید و با رشد خود مقیاس‌دهی کنید. بدون هزینه پنهان،
              بدون دردسر.
            </p>

            <!-- سوئیچ ماهانه/سالانه با تخفیف -->
            <div
              class="inline-flex items-center gap-3 bg-muted/50 backdrop-blur-sm rounded-full p-1.5 border border-white/5 shadow-lg"
            >
              <button
                :class="[
                  'px-6 py-2.5 rounded-full text-sm font-bold transition-all duration-300',
                  billingCycle === 'monthly'
                    ? 'bg-gradient-to-r from-[#eb4763] to-[#a347d1] text-white shadow-lg scale-105'
                    : 'text-muted-foreground hover:text-foreground hover:scale-105',
                ]"
                @click="billingCycle = 'monthly'"
              >
                ماهانه
              </button>
              <!-- <button
                :class="[
                  'px-6 py-2.5 rounded-full text-sm font-bold transition-all duration-300 flex items-center gap-2 relative overflow-hidden group',
                  billingCycle === 'annual'
                    ? 'bg-gradient-to-r from-[#eb4763] to-[#a347d1] text-white shadow-lg scale-105'
                    : 'text-muted-foreground hover:text-foreground hover:scale-105',
                ]"
                @click="billingCycle = 'annual'"
              >
                <span>سالانه</span>
                <span
                  class="px-2 py-0.5 rounded-full text-[10px] font-bold bg-white/20 backdrop-blur-sm text-white animate-pulse-soft group-hover:scale-110 transition-transform"
                >
                  ۲۰٪ تخفیف
                </span>
              </button> -->
            </div>
          </div>

          <!-- کارت‌های پلن - سه ستونه -->
          <div class="grid lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            <div
              v-for="(plan, index) in pricingPlans"
              :key="index"
              class="group relative rounded-3xl transition-all duration-500 animate-fade-in-up hover:scale-105 hover:-translate-y-2 flex flex-col h-full"
              :class="[plan.popular ? 'lg:-mt-4 lg:mb-4 z-10' : '']"
              :style="{ animationDelay: `${index * 150}ms` }"
            >
              <!-- کارت اصلی با افکت گرادینت دور -->
              <div
                class="relative rounded-3xl overflow-visible h-full flex flex-col"
              >
                <!-- لایه‌های گرادینت دور برای کارت محبوب -->
                <div
                  v-if="plan.popular"
                  class="absolute -inset-1 bg-gradient-to-r from-[#eb4763] via-[#a347d1] to-[#2eb8aa] rounded-3xl opacity-75 blur-xl group-hover:blur-2xl transition-all duration-700 animate-gradient-x bg-[length:200%_auto]"
                ></div>

                <!-- پس‌زمینه کارت با افکت شیشه‌ای و border برای همه پلن‌ها -->
                <div
                  class="absolute inset-0 bg-gradient-to-br from-card/90 to-card/50 backdrop-blur-sm border-2 border-white/10 rounded-3xl"
                  :class="[
                    plan.popular
                      ? 'bg-gradient-to-br from-[#eb4763]/10 to-[#a347d1]/10 border-[#eb4763]/30'
                      : 'hover:border-[#eb4763]/20 transition-colors duration-300',
                  ]"
                ></div>

                <!-- افکت هوور پیشرفته -->
                <div
                  class="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none overflow-hidden rounded-3xl"
                >
                  <div
                    class="absolute -inset-1 bg-gradient-to-r from-[#eb4763]/20 via-transparent to-[#2eb8aa]/20 blur-xl animate-shimmer-wave"
                  ></div>
                  <div
                    class="absolute top-0 -left-20 w-40 h-40 rounded-full blur-3xl animate-pulse-slow bg-gradient-to-r from-[#eb4763]/20 to-[#a347d1]/20"
                  ></div>
                  <div
                    class="absolute bottom-0 -right-20 w-40 h-40 rounded-full blur-3xl animate-pulse-slow animation-delay-1000 bg-gradient-to-r from-[#2eb8aa]/20 to-[#eb4763]/20"
                  ></div>
                </div>

                <!-- محتوای کارت -->
                <div class="relative p-8 flex flex-col h-full">
                  <!-- برچسب محبوب‌ترین - اصلاح شده برای نمایش کامل -->
                  <div
                    v-if="plan.popular"
                    class="absolute -top-4 left-1/2 -translate-x-1/2 px-6 py-1.5 rounded-full text-xs font-bold text-white whitespace-nowrap z-50 shadow-xl"
                    style="
                      background: linear-gradient(135deg, #eb4763, #a347d1);
                    "
                  >
                    <span class="flex items-center gap-1">
                      <span
                        class="w-1.5 h-1.5 rounded-full bg-white animate-pulse-soft"
                      ></span>
                      محبوب‌ترین طرح
                      <span
                        class="w-1.5 h-1.5 rounded-full bg-white animate-pulse-soft animation-delay-300"
                      ></span>
                    </span>
                  </div>

                  <!-- آیکون پلن با گرادینت -->
                  <div
                    class="w-14 h-14 rounded-2xl flex items-center justify-center mb-6 transition-all duration-300 group-hover:scale-110 group-hover:rotate-3"
                    :style="{ background: plan.gradient }"
                  >
                    <component :is="plan.icon" :size="28" class="text-white" />
                  </div>

                  <!-- عنوان و توضیحات -->
                  <h3 class="text-2xl font-bold text-foreground mb-2">
                    {{ plan.name }}
                  </h3>
                  <p class="text-sm text-muted-foreground mb-6">
                    {{ plan.description }}
                  </p>

                  <!-- قیمت با انیمیشن -->
                  <div class="mb-8">
                    <div class="flex items-end gap-1">
                      <span class="text-5xl font-extrabold text-foreground">
                        {{
                          billingCycle === "monthly"
                            ? plan.price
                            : plan.priceAnnual
                        }}
                      </span>
                    </div>
                    <div class="text-xs text-muted-foreground mt-1">
                      {{
                        billingCycle === "monthly"
                          ? "به ازای هر ماه"
                          : "به ازای هر سال"
                      }}
                    </div>
                    <!-- نمایش قیمت ماهانه برای طرح سالانه -->
                    <div
                      v-if="billingCycle === 'annual'"
                      class="mt-2 text-sm text-[#2eb8aa] font-semibold"
                    >
                      تنها
                      {{
                        Math.round(parseInt(plan.price.replace(",", "")) / 12)
                      }}تومان در ماه
                    </div>
                  </div>

                  <!-- خط جداکننده گرادینت -->
                  <div
                    class="w-full h-[2px] bg-gradient-to-r from-transparent via-[#eb4763]/30 to-transparent mb-6"
                  ></div>

                  <!-- ویژگی‌ها با چک‌مارک -->
                  <ul class="space-y-4 mb-8 flex-grow">
                    <li
                      v-for="(feature, fIndex) in plan.features"
                      :key="fIndex"
                      class="flex items-start gap-3 text-sm text-foreground group/item"
                    >
                      <div
                        class="w-5 h-5 rounded-full bg-gradient-to-br from-[#2eb8aa] to-[#2eb8aa]/70 flex items-center justify-center shrink-0 mt-0.5 group-hover/item:scale-110 transition-transform"
                      >
                        <Check :size="12" class="text-white" />
                      </div>
                      <span>{{ feature }}</span>
                    </li>
                  </ul>
                  <!-- دکمه اقدام با افکت ویژه -->
                  <button
                    v-if="
                      plan.link &&
                      !plan.link.includes('shopecom.ir') &&
                      !plan.link.includes('panel.shopecom.ir')
                    "
                    @click="window.open(plan.link, '_blank')"
                    class="w-full py-4 rounded-xl text-base font-bold transition-all duration-300 hover:scale-110 flex items-center justify-center gap-2 relative overflow-hidden group/btn mt-auto"
                    :class="[
                      plan.popular
                        ? 'text-white shadow-xl'
                        : 'border-2 border-[#eb4763]/20 text-foreground hover:bg-[#eb4763]/10 backdrop-blur-sm',
                    ]"
                    :style="{
                      background: plan.popular
                        ? 'linear-gradient(135deg, #eb4763, #a347d1)'
                        : '',
                    }"
                  >
                    <!-- افکت درخشش برای دکمه -->
                    <span
                      class="absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 translate-x-[-100%] group-hover/btn:translate-x-[100%] transition-transform duration-1000"
                    ></span>

                    <span> {{ plan.name }}</span>
                    <ArrowLeft
                      :size="18"
                      class="group-hover/btn:-translate-x-2 transition-transform"
                    />

                    <!-- افکت نورانی دور دکمه برای پلن محبوب -->
                    <span
                      v-if="plan.popular"
                      class="absolute -inset-1 rounded-xl opacity-0 group-hover/btn:opacity-50 blur-md transition-opacity duration-500"
                      style="
                        background: linear-gradient(
                          135deg,
                          #eb4763,
                          #a347d1,
                          #2eb8aa
                        );
                      "
                    ></span>
                  </button>

                  <!-- دکمه اقدام با افکت ویژه - برای لینک panel.shopecom.ir -->
                  <a
                    v-if="plan.link && plan.link.includes('panel.shopecom.ir')"
                    :href="plan.link"
                    target="_blank"
                    class="w-full py-4 rounded-xl text-base font-bold transition-all duration-300 hover:scale-110 flex items-center justify-center gap-2 relative overflow-hidden group/btn mt-auto"
                    :class="[
                      plan.popular
                        ? 'text-white shadow-xl'
                        : 'border-2 border-[#eb4763]/20 text-foreground hover:bg-[#eb4763]/10 backdrop-blur-sm',
                    ]"
                    :style="{
                      background: plan.popular
                        ? 'linear-gradient(135deg, #eb4763, #a347d1)'
                        : '',
                    }"
                  >
                    <!-- افکت درخشش برای دکمه -->
                    <span
                      class="absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 translate-x-[-100%] group-hover/btn:translate-x-[100%] transition-transform duration-1000"
                    ></span>

                    <span> {{ plan.name }}</span>
                    <ArrowLeft
                      :size="18"
                      class="group-hover/btn:-translate-x-2 transition-transform"
                    />

                    <!-- افکت نورانی دور دکمه برای پلن محبوب -->
                    <span
                      v-if="plan.popular"
                      class="absolute -inset-1 rounded-xl opacity-0 group-hover/btn:opacity-50 blur-md transition-opacity duration-500"
                      style="
                        background: linear-gradient(
                          135deg,
                          #eb4763,
                          #a347d1,
                          #2eb8aa
                        );
                      "
                    ></span>
                  </a>

                  <!-- دکمه با متن بزودی - برای لینک shopecom.ir -->
                  <button
                    v-else-if="
                      plan.link &&
                      plan.link.includes('shopecom.ir') &&
                      !plan.link.includes('panel')
                    "
                    disabled
                    class="w-full py-4 rounded-xl text-base font-bold transition-all duration-300 flex items-center justify-center gap-2 relative overflow-hidden group/btn mt-auto opacity-70 cursor-not-allowed"
                    :class="[
                      plan.popular
                        ? 'text-white shadow-xl'
                        : 'border-2 border-[#eb4763]/20 text-foreground',
                    ]"
                    :style="{
                      background: plan.popular
                        ? 'linear-gradient(135deg, #eb4763, #a347d1)'
                        : 'rgba(255,255,255,0.05)',
                    }"
                  >
                    <span>بزودی</span>
                    <Clock :size="18" />
                  </button>

                  <!-- حالت پیش‌فرض (اگر لینک دیگری باشه) -->
                  <a
                    v-else-if="plan.link"
                    :href="plan.link"
                    target="_blank"
                    class="w-full py-4 rounded-xl text-base font-bold transition-all duration-300 hover:scale-110 flex items-center justify-center gap-2 relative overflow-hidden group/btn mt-auto"
                    :class="[
                      plan.popular
                        ? 'text-white shadow-xl'
                        : 'border-2 border-[#eb4763]/20 text-foreground hover:bg-[#eb4763]/10 backdrop-blur-sm',
                    ]"
                    :style="{
                      background: plan.popular
                        ? 'linear-gradient(135deg, #eb4763, #a347d1)'
                        : '',
                    }"
                  >
                    <span>{{ plan.name }}</span>
                    <ArrowLeft
                      :size="18"
                      class="group-hover/btn:-translate-x-2 transition-transform"
                    />
                  </a>

                  <!-- اگر هیچ لینکی نباشه -->
                  <button
                    v-else
                    disabled
                    class="w-full py-4 rounded-xl text-base font-bold transition-all duration-300 flex items-center justify-center gap-2 relative overflow-hidden group/btn mt-auto opacity-70 cursor-not-allowed"
                    :class="[
                      plan.popular
                        ? 'text-white shadow-xl'
                        : 'border-2 border-[#eb4763]/20 text-foreground',
                    ]"
                    :style="{
                      background: plan.popular
                        ? 'linear-gradient(135deg, #eb4763, #a347d1)'
                        : 'rgba(255,255,255,0.05)',
                    }"
                  >
                    <span>بزودی</span>
                    <Clock :size="18" />
                  </button>

                  <!-- متن بدون کارت اعتباری -->
                  <p class="text-xs text-muted-foreground text-center mt-4">
                    بدون نیاز به کارت اعتباری • شروع رایگان ۱۴ روزه
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- ویژگی‌های اضافی پایین پلن‌ها -->
          <div
            class="mt-16 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto"
          >
            <div
              v-for="(extra, index) in extraFeatures"
              :key="index"
              class="flex items-center gap-3 p-4 rounded-xl bg-card/50 backdrop-blur-sm border border-white/5 animate-fade-in-up"
              :style="{ animationDelay: `${600 + index * 100}ms` }"
            >
              <div
                class="w-8 h-8 rounded-lg flex items-center justify-center"
                :style="{ background: extra.gradient + '20' }"
              >
                <component
                  :is="extra.icon"
                  :size="16"
                  :style="{
                    color: extra.gradient
                      .split(',')[0]
                      .replace('rgb(', '')
                      .replace(')', ''),
                  }"
                />
              </div>
              <span class="text-xs font-medium text-foreground">{{
                extra.text
              }}</span>
            </div>
          </div>

          <!-- سوالات متداول سریع -->
          <div
            class="mt-12 text-center animate-fade-in-up animation-delay-1000"
          >
            <p class="text-muted-foreground text-sm">
              سوالی دارید؟
              <router-link
                to="/faq"
                class="text-[#eb4763] font-semibold hover:underline transition-all"
              >
                با تیم فروش صحبت کنید
              </router-link>
            </p>
          </div>
        </div>
      </section>

      <!-- بخش پشتیبانی (Support) -->
      <section
        id="support"
        class="section-padding relative overflow-hidden"
        style="padding: 20px"
      >
        <!-- المان‌های متحرک پس‌زمینه -->
        <div class="absolute inset-0 pointer-events-none overflow-hidden">
          <div
            class="absolute top-40 -right-20 w-72 h-72 rounded-full opacity-20 blur-3xl animate-float-slow bg-gradient-to-br from-[#eb4763] to-[#a347d1]"
          ></div>
          <div
            class="absolute bottom-40 -left-20 w-80 h-80 rounded-full opacity-20 blur-3xl animate-float-slow animation-delay-2000 bg-gradient-to-tl from-[#2eb8aa] to-[#eb4763]"
          ></div>

          <!-- خطوط نورانی متحرک -->
          <div
            class="absolute top-1/3 right-10 w-40 h-[2px] rotate-45 bg-gradient-to-r from-transparent via-[#eb4763] to-transparent blur-sm animate-pulse-slow"
          ></div>
          <div
            class="absolute bottom-1/3 left-10 w-40 h-[2px] -rotate-45 bg-gradient-to-r from-transparent via-[#2eb8aa] to-transparent blur-sm animate-pulse-slow animation-delay-1000"
          ></div>

          <!-- ذرات نورانی رقصان -->
          <div
            v-for="i in 8"
            :key="i"
            class="absolute w-1 h-1 rounded-full"
            :style="{
              top: Math.random() * 100 + '%',
              left: Math.random() * 100 + '%',
              background: `linear-gradient(135deg, ${
                ['#eb4763', '#a347d1', '#2eb8aa'][i % 3]
              }, transparent)`,
              animation: `float-particle ${
                8 + Math.random() * 5
              }s ease-in-out infinite`,
              animationDelay: Math.random() * 3 + 's',
              opacity: 0.2,
            }"
          ></div>
        </div>

        <div class="container mx-auto relative z-10">
          <!-- هدر بخش -->
          <div class="text-center mb-16 animate-fade-in-up">
            <span
              class="inline-block px-4 py-1.5 rounded-full bg-gradient-to-r from-[#eb4763]/10 to-[#a347d1]/10 border border-[#eb4763]/20 text-xs font-semibold text-foreground mb-4 tracking-wide uppercase backdrop-blur-sm"
            >
              پشتیبانی ۲۴/۷
            </span>
            <h2
              class="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-foreground mb-4"
            >
              همیشه
              <span
                class="bg-gradient-to-r from-[#eb4763] via-[#a347d1] to-[#2eb8aa] bg-clip-text text-transparent animate-gradient-x bg-[length:200%_auto]"
                >کنارتان</span
              >
              هستیم
            </h2>
            <p
              class="text-muted-foreground text-lg max-w-2xl mx-auto animate-fade-in-up animation-delay-200"
            >
              تیم پشتیبانی متخصص ما ۲۴ ساعت شبانه‌روز، ۷ روز هفته آماده پاسخگویی
              به سوالات شماست
            </p>
          </div>

          <!-- کارت‌های اصلی پشتیبانی - سه ستونه -->
          <div class="grid lg:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <!-- کارت چت زنده -->
            <div
              class="group relative rounded-3xl transition-all duration-500 animate-fade-in-up hover:scale-105 hover:-translate-y-2 flex flex-col h-full"
            >
              <!-- لایه گرادینت دور -->
              <div
                class="absolute -inset-1 bg-gradient-to-r from-[#eb4763] via-[#a347d1] to-[#2eb8aa] rounded-3xl opacity-0 group-hover:opacity-75 blur-xl transition-all duration-700 animate-gradient-x bg-[length:200%_auto]"
              ></div>

              <!-- پس‌زمینه کارت -->
              <div
                class="absolute inset-0 bg-gradient-to-br from-card/90 to-card/50 backdrop-blur-sm border-2 border-white/10 rounded-3xl hover:border-[#eb4763]/20 transition-colors duration-300"
              ></div>

              <!-- افکت هوور -->
              <div
                class="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none overflow-hidden rounded-3xl"
              >
                <div
                  class="absolute -inset-1 bg-gradient-to-r from-[#eb4763]/20 via-transparent to-[#2eb8aa]/20 blur-xl animate-shimmer-wave"
                ></div>
                <div
                  class="absolute top-0 -left-20 w-40 h-40 rounded-full blur-3xl animate-pulse-slow bg-gradient-to-r from-[#eb4763]/20 to-[#a347d1]/20"
                ></div>
                <div
                  class="absolute bottom-0 -right-20 w-40 h-40 rounded-full blur-3xl animate-pulse-slow animation-delay-1000 bg-gradient-to-r from-[#2eb8aa]/20 to-[#eb4763]/20"
                ></div>
              </div>

              <!-- محتوای کارت -->
              <div class="relative p-8 flex flex-col h-full">
                <!-- آیکون با گرادینت -->
                <div
                  class="w-16 h-16 rounded-2xl flex items-center justify-center mb-6 transition-all duration-300 group-hover:scale-110 group-hover:rotate-3"
                  style="background: linear-gradient(135deg, #eb4763, #a347d1)"
                >
                  <MessageCircle :size="32" class="text-white" />
                </div>

                <!-- عنوان و توضیحات -->
                <h3 class="text-2xl font-bold text-foreground mb-3">چت زنده</h3>
                <p class="text-sm text-muted-foreground mb-6 leading-relaxed">
                  سریع‌ترین راه برای ارتباط با تیم پشتیبانی. میانگین زمان
                  پاسخگویی کمتر از ۳ دقیقه.
                </p>

                <!-- ویژگی‌ها -->
                <ul class="space-y-3 mb-8 flex-grow">
                  <li class="flex items-center gap-3 text-sm text-foreground">
                    <div
                      class="w-5 h-5 rounded-full bg-gradient-to-br from-[#2eb8aa] to-[#2eb8aa]/70 flex items-center justify-center shrink-0"
                    >
                      <Check :size="12" class="text-white" />
                    </div>
                    <span>پاسخگویی فوری</span>
                  </li>
                  <li class="flex items-center gap-3 text-sm text-foreground">
                    <div
                      class="w-5 h-5 rounded-full bg-gradient-to-br from-[#2eb8aa] to-[#2eb8aa]/70 flex items-center justify-center shrink-0"
                    >
                      <Check :size="12" class="text-white" />
                    </div>
                    <span>پشتیبانی به زبان فارسی</span>
                  </li>
                  <li class="flex items-center gap-3 text-sm text-foreground">
                    <div
                      class="w-5 h-5 rounded-full bg-gradient-to-br from-[#2eb8aa] to-[#2eb8aa]/70 flex items-center justify-center shrink-0"
                    >
                      <Check :size="12" class="text-white" />
                    </div>
                    <span>۷ روز هفته، ۲۴ ساعته</span>
                  </li>
                </ul>

                <!-- دکمه اقدام -->
                <button
                  class="w-full py-4 rounded-xl text-base font-bold transition-all duration-300 hover:scale-110 flex items-center justify-center gap-2 relative overflow-hidden group/btn border-2 border-[#eb4763]/20 text-foreground hover:bg-[#eb4763]/10 backdrop-blur-sm"
                >
                  <span
                    class="absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 translate-x-[-100%] group-hover/btn:translate-x-[100%] transition-transform duration-1000"
                  ></span>
                  <span>شروع چت زنده</span>
                  <ArrowLeft
                    :size="18"
                    class="group-hover/btn:-translate-x-2 transition-transform"
                  />
                </button>
              </div>
            </div>

            <!-- کارت تیکتینگ -->
            <div
              class="group relative rounded-3xl transition-all duration-500 animate-fade-in-up hover:scale-105 hover:-translate-y-2 flex flex-col h-full"
              :style="{ animationDelay: '150ms' }"
            >
              <!-- لایه گرادینت دور -->
              <div
                class="absolute -inset-1 bg-gradient-to-r from-[#2eb8aa] via-[#38a89d] to-[#eb4763] rounded-3xl opacity-0 group-hover:opacity-75 blur-xl transition-all duration-700 animate-gradient-x bg-[length:200%_auto]"
              ></div>

              <!-- پس‌زمینه کارت -->
              <div
                class="absolute inset-0 bg-gradient-to-br from-card/90 to-card/50 backdrop-blur-sm border-2 border-white/10 rounded-3xl hover:border-[#2eb8aa]/20 transition-colors duration-300"
              ></div>

              <!-- افکت هوور -->
              <div
                class="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none overflow-hidden rounded-3xl"
              >
                <div
                  class="absolute -inset-1 bg-gradient-to-r from-[#2eb8aa]/20 via-transparent to-[#eb4763]/20 blur-xl animate-shimmer-wave"
                ></div>
              </div>

              <!-- محتوای کارت -->
              <div class="relative p-8 flex flex-col h-full">
                <!-- آیکون با گرادینت -->
                <div
                  class="w-16 h-16 rounded-2xl flex items-center justify-center mb-6 transition-all duration-300 group-hover:scale-110 group-hover:rotate-3"
                  style="background: linear-gradient(135deg, #2eb8aa, #38a89d)"
                >
                  <Ticket :size="32" class="text-white" />
                </div>

                <h3 class="text-2xl font-bold text-foreground mb-3">
                  سیستم تیکتینگ
                </h3>
                <p class="text-sm text-muted-foreground mb-6 leading-relaxed">
                  برای مسائل پیچیده‌تر که نیاز به بررسی دقیق دارند، تیکت ثبت
                  کنید.
                </p>

                <ul class="space-y-3 mb-8 flex-grow">
                  <li class="flex items-center gap-3 text-sm text-foreground">
                    <div
                      class="w-5 h-5 rounded-full bg-gradient-to-br from-[#eb4763] to-[#eb4763]/70 flex items-center justify-center shrink-0"
                    >
                      <Check :size="12" class="text-white" />
                    </div>
                    <span>پاسخگویی حداکثر ۲۴ ساعت</span>
                  </li>
                  <li class="flex items-center gap-3 text-sm text-foreground">
                    <div
                      class="w-5 h-5 rounded-full bg-gradient-to-br from-[#eb4763] to-[#eb4763]/70 flex items-center justify-center shrink-0"
                    >
                      <Check :size="12" class="text-white" />
                    </div>
                    <span>پیگیری آنلاین وضعیت تیکت</span>
                  </li>
                  <li class="flex items-center gap-3 text-sm text-foreground">
                    <div
                      class="w-5 h-5 rounded-full bg-gradient-to-br from-[#eb4763] to-[#eb4763]/70 flex items-center justify-center shrink-0"
                    >
                      <Check :size="12" class="text-white" />
                    </div>
                    <span>ارسال فایل و تصویر</span>
                  </li>
                </ul>

                <button
                  class="w-full py-4 rounded-xl text-base font-bold transition-all duration-300 hover:scale-110 flex items-center justify-center gap-2 relative overflow-hidden group/btn border-2 border-[#2eb8aa]/20 text-foreground hover:bg-[#2eb8aa]/10 backdrop-blur-sm"
                >
                  <span
                    class="absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 translate-x-[-100%] group-hover/btn:translate-x-[100%] transition-transform duration-1000"
                  ></span>
                  <span>ثبت تیکت جدید</span>
                  <ArrowLeft
                    :size="18"
                    class="group-hover/btn:-translate-x-2 transition-transform"
                  />
                </button>
              </div>
            </div>

            <!-- کارت تماس تلفنی -->
            <div
              class="group relative rounded-3xl transition-all duration-500 animate-fade-in-up hover:scale-105 hover:-translate-y-2 flex flex-col h-full"
              :style="{ animationDelay: '300ms' }"
            >
              <!-- لایه گرادینت دور -->
              <div
                class="absolute -inset-1 bg-gradient-to-r from-[#a347d1] via-[#dd3ca7] to-[#eb4763] rounded-3xl opacity-0 group-hover:opacity-75 blur-xl transition-all duration-700 animate-gradient-x bg-[length:200%_auto]"
              ></div>

              <!-- پس‌زمینه کارت -->
              <div
                class="absolute inset-0 bg-gradient-to-br from-card/90 to-card/50 backdrop-blur-sm border-2 border-white/10 rounded-3xl hover:border-[#a347d1]/20 transition-colors duration-300"
              ></div>

              <!-- محتوای کارت -->
              <div class="relative p-8 flex flex-col h-full">
                <!-- آیکون با گرادینت -->
                <div
                  class="w-16 h-16 rounded-2xl flex items-center justify-center mb-6 transition-all duration-300 group-hover:scale-110 group-hover:rotate-3"
                  style="background: linear-gradient(135deg, #a347d1, #dd3ca7)"
                >
                  <Phone :size="32" class="text-white" />
                </div>

                <h3 class="text-2xl font-bold text-foreground mb-3">
                  پشتیبانی تلفنی
                </h3>
                <p class="text-sm text-muted-foreground mb-6 leading-relaxed">
                  در ساعات اداری با کارشناسان ما به صورت مستقیم صحبت کنید.
                </p>

                <ul class="space-y-3 mb-8 flex-grow">
                  <li class="flex items-center gap-3 text-sm text-foreground">
                    <div
                      class="w-5 h-5 rounded-full bg-gradient-to-br from-[#eb4763] to-[#a347d1] flex items-center justify-center shrink-0"
                    >
                      <Check :size="12" class="text-white" />
                    </div>
                    <span>شنبه تا پنجشنبه ۸ صبح تا ۸ شب</span>
                  </li>
                  <li class="flex items-center gap-3 text-sm text-foreground">
                    <div
                      class="w-5 h-5 rounded-full bg-gradient-to-br from-[#eb4763] to-[#a347d1] flex items-center justify-center shrink-0"
                    >
                      <Check :size="12" class="text-white" />
                    </div>
                    <span>خط ویژه پشتیبانی</span>
                  </li>
                  <li class="flex items-center gap-3 text-sm text-foreground">
                    <div
                      class="w-5 h-5 rounded-full bg-gradient-to-br from-[#eb4763] to-[#a347d1] flex items-center justify-center shrink-0"
                    >
                      <Check :size="12" class="text-white" />
                    </div>
                    <span>مشاوره تخصصی رایگان</span>
                  </li>
                </ul>

                <div class="text-center mb-4">
                  <span
                    class="text-2xl font-bold text-transparent bg-gradient-to-r from-[#a347d1] to-[#eb4763] bg-clip-text"
                  >
                    09027726940
                  </span>
                </div>

                <button
                  class="w-full py-4 rounded-xl text-base font-bold transition-all duration-300 hover:scale-110 flex items-center justify-center gap-2 relative overflow-hidden group/btn border-2 border-[#a347d1]/20 text-foreground hover:bg-[#a347d1]/10 backdrop-blur-sm"
                >
                  <span
                    class="absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 translate-x-[-100%] group-hover/btn:translate-x-[100%] transition-transform duration-1000"
                  ></span>
                  <span>درخواست تماس</span>
                  <Phone
                    :size="18"
                    class="group-hover/btn:-translate-x-2 transition-transform"
                  />
                </button>
              </div>
            </div>
          </div>

          <!-- بخش پایین با اطلاعات تماس اضافی -->
          <div class="mt-16 grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
            <!-- کارت ایمیل -->
            <div
              class="group relative rounded-2xl overflow-hidden animate-fade-in-up hover:scale-105 transition-all duration-300"
              :style="{ animationDelay: '450ms' }"
            >
              <div
                class="absolute inset-0 bg-gradient-to-r from-[#eb4763]/10 to-[#a347d1]/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
              ></div>
              <div
                class="relative p-6 bg-card/50 backdrop-blur-sm border border-white/5 rounded-2xl flex items-center gap-4"
              >
                <div
                  class="w-12 h-12 rounded-xl flex items-center justify-center shrink-0"
                  style="background: linear-gradient(135deg, #eb4763, #a347d1)"
                >
                  <Mail :size="20" class="text-white" />
                </div>
                <div>
                  <div class="text-sm text-muted-foreground mb-1">
                    پست الکترونیک
                  </div>
                  <div class="text-lg font-bold text-foreground">
                    info@shopecom.ir
                  </div>
                  <div class="text-xs text-muted-foreground mt-1">
                    پاسخگویی ظرف ۴ ساعت
                  </div>
                </div>
                <button
                  class="mr-auto p-2 rounded-lg hover:bg-white/5 transition-colors"
                >
                  <Copy :size="18" class="text-muted-foreground" />
                </button>
              </div>
            </div>

            <!-- کارت واتساپ/تلگرام -->
            <div
              class="group relative rounded-2xl overflow-hidden animate-fade-in-up hover:scale-105 transition-all duration-300"
              :style="{ animationDelay: '600ms' }"
            >
              <div
                class="absolute inset-0 bg-gradient-to-r from-[#2eb8aa]/10 to-[#38a89d]/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
              ></div>
              <div
                class="relative p-6 bg-card/50 backdrop-blur-sm border border-white/5 rounded-2xl flex items-center gap-4"
              >
                <div
                  class="w-12 h-12 rounded-xl flex items-center justify-center shrink-0"
                  style="background: linear-gradient(135deg, #2eb8aa, #38a89d)"
                >
                  <MessageSquare :size="20" class="text-white" />
                </div>
                <div>
                  <div class="text-sm text-muted-foreground mb-1">
                    پیام‌رسان‌ها
                  </div>
                  <div class="text-lg font-bold text-foreground">
                    @shopecom_support
                  </div>
                  <div class="text-xs text-muted-foreground mt-1">
                    واتساپ، تلگرام، ایتا
                  </div>
                </div>
                <button
                  class="mr-auto p-2 rounded-lg hover:bg-white/5 transition-colors"
                >
                  <ExternalLink :size="18" class="text-muted-foreground" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- بخش FAQ -->
      <section
        id="faq"
        class="section-padding relative overflow-hidden"
        style="padding: 20px"
      >
        <!-- المان‌های متحرک پس‌زمینه -->
        <div class="absolute inset-0 pointer-events-none overflow-hidden">
          <div
            class="absolute top-40 right-20 w-72 h-72 rounded-full opacity-20 blur-3xl animate-float-slow bg-gradient-to-br from-[#eb4763] to-[#a347d1]"
          ></div>
          <div
            class="absolute bottom-40 left-20 w-80 h-80 rounded-full opacity-20 blur-3xl animate-float-slow animation-delay-2000 bg-gradient-to-tl from-[#2eb8aa] to-[#eb4763]"
          ></div>

          <!-- خطوط نورانی متحرک -->
          <div
            class="absolute top-1/4 right-10 w-40 h-[2px] rotate-45 bg-gradient-to-r from-transparent via-[#eb4763] to-transparent blur-sm animate-pulse-slow"
          ></div>
          <div
            class="absolute bottom-1/4 left-10 w-40 h-[2px] -rotate-45 bg-gradient-to-r from-transparent via-[#2eb8aa] to-transparent blur-sm animate-pulse-slow animation-delay-1000"
          ></div>

          <!-- ذرات نورانی رقصان -->
          <div
            v-for="i in 6"
            :key="`faq-particle-${i}`"
            class="absolute w-1 h-1 rounded-full"
            :style="{
              top: Math.random() * 100 + '%',
              left: Math.random() * 100 + '%',
              background: `linear-gradient(135deg, ${
                ['#eb4763', '#a347d1', '#2eb8aa'][i % 3]
              }, transparent)`,
              animation: `float-particle ${
                8 + Math.random() * 5
              }s ease-in-out infinite`,
              animationDelay: Math.random() * 3 + 's',
              opacity: 0.2,
            }"
          ></div>
        </div>

        <div class="container mx-auto relative z-10">
          <!-- هدر بخش -->
          <div class="text-center mb-16 animate-fade-in-up">
            <span
              class="inline-block px-4 py-1.5 rounded-full bg-gradient-to-r from-[#eb4763]/10 to-[#a347d1]/10 border border-[#eb4763]/20 text-xs font-semibold text-foreground mb-4 tracking-wide uppercase backdrop-blur-sm"
            >
              سوالات متداول
            </span>
            <h2
              class="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-foreground mb-4"
            >
              پاسخ به
              <span
                class="bg-gradient-to-r from-[#eb4763] via-[#a347d1] to-[#2eb8aa] bg-clip-text text-transparent animate-gradient-x bg-[length:200%_auto]"
                >سوالات</span
              >
              شما
            </h2>
            <p
              class="text-muted-foreground text-lg max-w-2xl mx-auto animate-fade-in-up animation-delay-200"
            >
              هر آنچه که باید درباره شاپیکام بدانید. اگر سوال دیگری دارید، تیم
              پشتیبانی آماده کمک است.
            </p>
          </div>

          <!-- شبکه FAQ - دو ستونه -->
          <div class="grid lg:grid-cols-2 gap-6 max-w-5xl mx-auto">
            <div
              v-for="(faq, index) in faqItems"
              :key="index"
              class="group relative rounded-2xl transition-all duration-500 animate-fade-in-up"
              :style="{ animationDelay: `${index * 100}ms` }"
            >
              <!-- کارت سوال با افکت گرادینت -->
              <div class="relative rounded-2xl overflow-hidden h-full">
                <!-- لایه گرادینت دور در هاور -->
                <div
                  class="absolute -inset-0.5 bg-gradient-to-r from-[#eb4763] via-[#a347d1] to-[#2eb8aa] rounded-2xl opacity-0 group-hover:opacity-75 blur-md transition-all duration-700 animate-gradient-x bg-[length:200%_auto]"
                ></div>

                <!-- پس‌زمینه کارت -->
                <div
                  class="absolute inset-0 bg-gradient-to-br from-card/90 to-card/50 backdrop-blur-sm border-2 border-white/10 rounded-2xl group-hover:border-[#eb4763]/30 transition-colors duration-300"
                ></div>

                <!-- افکت نور در هاور -->
                <div
                  class="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none"
                >
                  <div
                    class="absolute -inset-1 bg-gradient-to-r from-[#eb4763]/10 via-transparent to-[#2eb8aa]/10 blur-xl"
                  ></div>
                </div>

                <!-- محتوای کارت -->
                <div
                  class="relative p-6 cursor-pointer"
                  @click="toggleFaq(index)"
                >
                  <div class="flex items-start gap-4">
                    <!-- آیکون سوال با گرادینت -->
                    <div
                      class="w-10 h-10 rounded-xl flex items-center justify-center shrink-0 transition-all duration-300 group-hover:scale-110 group-hover:rotate-3"
                      :style="{ background: faq.gradient }"
                    >
                      <component :is="faq.icon" :size="18" class="text-white" />
                    </div>

                    <div class="flex-1">
                      <!-- سوال -->
                      <h3
                        class="text-base font-bold text-foreground mb-2 group-hover:text-white group-hover:bg-gradient-to-r group-hover:from-[#eb4763] group-hover:to-[#a347d1] group-hover:bg-clip-text transition-all"
                      >
                        {{ faq.question }}
                      </h3>

                      <!-- پاسخ با انیمیشن ارتفاع -->
                      <transition @enter="onEnter" @leave="onLeave">
                        <div v-show="openFaqs[index]" class="overflow-hidden">
                          <p
                            class="text-sm text-muted-foreground leading-relaxed pt-2 border-t border-white/10 mt-2"
                          >
                            {{ faq.answer }}
                          </p>
                        </div>
                      </transition>
                    </div>

                    <!-- دکمه باز/بسته کردن با انیمیشن -->
                    <button
                      class="w-8 h-8 rounded-lg flex items-center justify-center transition-all duration-300 group-hover:scale-110"
                      :style="{
                        background: openFaqs[index]
                          ? 'linear-gradient(135deg, #eb4763, #a347d1)'
                          : 'rgba(255,255,255,0.05)',
                      }"
                      @click.stop="toggleFaq(index)"
                    >
                      <ChevronDown
                        :size="16"
                        class="transition-transform duration-300"
                        :class="{ 'rotate-180': openFaqs[index] }"
                        :style="{ color: openFaqs[index] ? '#ffffff' : '#666' }"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- بخش تماس سریع -->
          <div
            class="mt-12 text-center animate-fade-in-up animation-delay-1000"
          >
            <div
              class="inline-flex flex-wrap items-center justify-center gap-3 px-6 py-4 rounded-2xl bg-gradient-to-r from-[#eb4763]/10 to-[#a347d1]/10 border border-[#eb4763]/20 backdrop-blur-sm"
            >
              <span class="text-sm text-foreground"
                >پاسخ سوال خود را پیدا نکردید؟</span
              >
              <router-link
                to="support"
                class="inline-flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-bold text-white transition-all duration-300 hover:scale-110 hover:shadow-xl relative overflow-hidden group"
                style="background: linear-gradient(135deg, #eb4763, #a347d1)"
              >
                <span
                  class="absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000"
                ></span>
                <span>تماس با پشتیبانی</span>
                <Headphones
                  :size="14"
                  class="group-hover:rotate-12 transition-transform"
                />
              </router-link>
              <span class="text-sm text-muted-foreground">یا</span>
              <router-link
                to="/faq"
                class="text-sm font-semibold text-transparent bg-gradient-to-r from-[#eb4763] to-[#a347d1] bg-clip-text hover:underline"
              >
                مستندات را مطالعه کنید
              </router-link>
            </div>
          </div>
        </div>
      </section>
      <!-- بخش Testimonials با ذرات رقصان -->
      <section
        class="section-padding relative overflow-hidden"
        style="padding: 20px"
      >
        <!-- ذرات رقصان -->
        <div class="absolute inset-0 pointer-events-none">
          <div
            v-for="i in 6"
            :key="i"
            class="absolute w-1 h-1 rounded-full bg-primary/30"
            :style="{
              top: Math.random() * 100 + '%',
              left: Math.random() * 100 + '%',
              animation: `float-particle ${
                3 + Math.random() * 4
              }s ease-in-out infinite`,
              animationDelay: Math.random() * 2 + 's',
            }"
          ></div>
        </div>

        <div class="container mx-auto relative z-10">
          <div class="text-center mb-12 animate-fade-in-up">
            <span
              class="inline-block px-4 py-1.5 rounded-full bg-muted text-xs font-semibold text-primary mb-4 tracking-wide uppercase"
            >
              نظرات مشتریان
            </span>
            <h2 class="text-3xl sm:text-4xl font-extrabold text-foreground">
              مورد علاقه
              <span class="gradient-text animate-gradient-x">فروشندگان</span>
            </h2>
          </div>

          <div class="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
            <div
              v-for="(testimonial, index) in testimonials"
              :key="index"
              class="bg-card rounded-2xl p-6 sm:p-8 shadow-card gradient-border animate-fade-in-up hover:scale-105 transition-all duration-300 flex flex-col h-full"
              :style="{ animationDelay: `${index * 150}ms` }"
            >
              <div
                class="w-10 h-10 rounded-xl flex items-center justify-center mb-4 animate-bounce-soft"
                style="background: linear-gradient(135deg, #eb4763, #a347d1)"
              >
                <Quote :size="18" class="text-primary-foreground" />
              </div>

              <!-- متن نظر با flex-grow برای هم‌اندازه شدن -->
              <p class="text-foreground text-sm leading-relaxed mb-6 flex-grow">
                {{ testimonial.text }}
              </p>

              <!-- ستاره‌ها - همگی در یک خط -->
              <div class="flex items-center gap-1 mb-4 justify-start">
                <Star
                  v-for="star in 5"
                  :key="star"
                  :size="14"
                  class="text-accent animate-pulse-soft fill-current"
                  :style="{ animationDelay: `${star * 100}ms` }"
                />
              </div>

              <!-- اطلاعات کاربر -->
              <div class="flex items-center gap-3 mt-auto">
                <div
                  class="w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold text-primary-foreground animate-pulse-soft shrink-0"
                  style="background: linear-gradient(135deg, #eb4763, #a347d1)"
                >
                  {{ testimonial.initial }}
                </div>
                <div class="min-w-0">
                  <div class="text-sm font-bold text-foreground truncate">
                    {{ testimonial.name }}
                  </div>
                  <div class="text-xs text-muted-foreground truncate">
                    {{ testimonial.store }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <!-- CTA Section با موج‌های متحرک -->
      <section
        class="section-padding relative overflow-hidden"
        style="padding: 20px"
      >
        <!-- موج‌های متحرک -->
        <div class="absolute inset-0 pointer-events-none overflow-hidden">
          <svg
            class="absolute bottom-0 left-0 w-full h-32"
            viewBox="0 0 1440 320"
            preserveAspectRatio="none"
          >
            <path fill="rgba(255,255,255,0.05)" fill-opacity="1">
              <animate
                attributeName="d"
                dur="10s"
                repeatCount="indefinite"
                values="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,154.7C960,171,1056,181,1152,170.7C1248,160,1344,128,1392,112L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z;
                          
                          M0,224L48,213.3C96,203,192,181,288,181.3C384,181,480,203,576,202.7C672,203,768,181,864,170.7C960,160,1056,160,1152,170.7C1248,181,1344,203,1392,213.3L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z;
                          
                          M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,154.7C960,171,1056,181,1152,170.7C1248,160,1344,128,1392,112L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
              ></animate>
            </path>
          </svg>
        </div>

        <div class="container mx-auto relative z-10">
          <div
            class="relative rounded-3xl overflow-hidden px-8 py-16 sm:px-16 sm:py-20 text-center animate-fade-in-up"
            style="background: linear-gradient(135deg, #eb4763, #a347d1)"
          >
            <div
              class="absolute top-0 right-0 w-64 h-64 rounded-full bg-primary-foreground/10 translate-x-1/2 -translate-y-1/2 animate-float-slow"
            ></div>
            <div
              class="absolute bottom-0 left-0 w-96 h-96 rounded-full bg-primary-foreground/5 -translate-x-1/3 translate-y-1/3 animate-float-slow animation-delay-2000"
            ></div>

            <div class="relative z-10">
              <h2
                class="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-primary-foreground mb-4 animate-fade-in-up"
              >
                امروز فروشگاه خود را بسازید
              </h2>

              <p
                class="text-lg text-primary-foreground/80 max-w-xl mx-auto mb-8 animate-fade-in-up animation-delay-200"
              >
                ۱۴ روز آزمایشی رایگان، بدون نیاز به کارت اعتباری. به ۲۳,۰۰۰+
                فروشنده که به شاپیکام اعتماد دارند بپیوندید
              </p>

              <a
                href="https://panel.shopecom.ir/"
                class="inline-flex items-center gap-2 px-10 py-4 rounded-2xl bg-card text-foreground text-lg font-bold shadow-card hover:shadow-elevated transition-all duration-300 hover:scale-110 group relative overflow-hidden"
                tabindex="0"
              >
                <span
                  class="absolute inset-0 bg-gradient-to-l from-primary/0 via-primary/20 to-primary-foreground/0 translate-x-full group-hover:-translate-x-full transition-transform duration-1000"
                ></span>
                شروع رایگان
                <ArrowLeft
                  :size="20"
                  class="group-hover:-translate-x-2 transition-transform"
                />
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>


<script>
import {
  Zap,
  Search,
  Headphones,
  Palette,
  Smartphone,
  ChartColumn,
  Eye,
  DollarSign,
  Users,
  ShoppingBag,
  TrendingUp,
  ArrowLeft,
  Play,
  Activity,
  Check,
  ExternalLink,
  Quote,
  Star,
  Clock,
  Rocket,
  Briefcase,
  Crown,
  CreditCard,
  Headphones as HeadphonesIcon,
  Database,
  BarChart,
  MessageCircle,
  Ticket,
  Phone,
  Mail,
  Copy,
  MessageSquare,
  ChevronDown,
  Heart,
  Grid,
  ShoppingCart,
  Utensils,
  Shirt,
  BookOpen,
  Laptop,
  Home,
  Gift,
  Shield,
  HelpCircle,
  Settings,
  Globe,
  RefreshCw,
  Download,
} from "lucide-vue-next";

export default {
  name: "HomeBody",
  components: {
    Zap,
    Search,
    Headphones,
    Palette,
    Smartphone,
    ChartColumn,
    Eye,
    DollarSign,
    Users,
    ShoppingBag,
    TrendingUp,
    ArrowLeft,
    Play,
    Activity,
    Check,
    ExternalLink,
    Quote,
    Star,
    Clock,
    Rocket,
    Briefcase,
    Crown,
    CreditCard,
    HeadphonesIcon,
    Database,
    BarChart,
    MessageCircle,
    Ticket,
    Phone,
    Mail,
    Copy,
    MessageSquare,
    ChevronDown,
    Heart,
    Grid,
    ShoppingCart,
    Utensils,
    Shirt,
    BookOpen,
    Laptop,
    Home,
    Gift,
    Shield,
    HelpCircle,
    Settings,
    Globe,
    RefreshCw,
    Download,
  },
  data() {
    return {
      billingCycle: "monthly",
      selectedTemplateCategory: "all",
      openFaqs: [], // اینجا مقداردهی اولیه می‌شود
      features: [
        {
          icon: "Zap",
          title: "سرعت فوق‌العاده",
          description:
            "زمان بارگذاری سریع تضمین می‌کند مشتریان شما هرگز منتظر نمی‌مانند. زیرساخت بهینه برای عملکرد بالا.",
          gradient:
            "linear-gradient(135deg, rgb(235, 71, 99), rgb(245, 153, 61))",
        },
        {
          icon: "Search",
          title: "سئوی پیشرفته",
          description:
            "ابزارهای سئوی داخلی برای رتبه‌بندی بالاتر فروشگاه شما. متا تگ‌ها، نقشه سایت و نشانه‌گذاری خودکار.",
          gradient:
            "linear-gradient(135deg, rgb(46, 184, 170), rgb(38, 157, 217))",
        },
        {
          icon: "Headphones",
          title: "پشتیبانی ۲۴/۷",
          description:
            "پشتیبانی متخصص در تمام ساعات شبانه‌روز از طریق چت، ایمیل و تلفن. همیشه وقتی نیاز دارید اینجا هستیم.",
          gradient:
            "linear-gradient(135deg, rgb(163, 71, 209), rgb(221, 60, 167))",
        },
        {
          icon: "Palette",
          title: "شخصی‌سازی آسان",
          description:
            "سازنده کشیدن و رها کردن با بیش از ۲۰۰ قالب. بدون نیاز به کدنویسی برای ایجاد یک فروشگاه خیره‌کننده.",
          gradient:
            "linear-gradient(135deg, rgb(249, 195, 31), rgb(244, 140, 37))",
        },
        {
          icon: "Smartphone",
          title: "بهینه برای موبایل",
          description:
            "هر فروشگاه به طور پیش‌فرض موبایل‌فرست است. طراحی‌های واکن‌گرا که در هر دستگاهی تبدیل بالایی دارند.",
          gradient:
            "linear-gradient(135deg, rgb(60, 113, 221), rgb(46, 184, 170))",
        },
        {
          icon: "ChartColumn",
          title: "ابزارهای بازاریابی",
          description:
            "کمپین‌های ایمیل، کدهای تخفیف، فروش اجتماعی و تحلیل‌های آماری همه در یک جا.",
          gradient:
            "linear-gradient(135deg, rgb(46, 184, 92), rgb(46, 184, 170))",
        },
      ],
      stats: [
        {
          icon: "Eye",
          value: "۱٬۲۴۷",
          label: "بازدیدکنندگان آنلاین",
          gradient:
            "linear-gradient(135deg, rgb(60, 113, 221), rgb(163, 71, 209))",
        },
        {
          icon: "DollarSign",
          value: "۳۴٬۵۸۰",
          label: "درآمد امروز",
          gradient:
            "linear-gradient(135deg, rgb(46, 184, 92), rgb(46, 184, 170))",
        },
        {
          icon: "Users",
          value: "۲۳٬۴۱۲",
          label: "فروشگاه‌های فعال",
          gradient:
            "linear-gradient(135deg, rgb(235, 71, 99), rgb(245, 153, 61))",
        },
        {
          icon: "ShoppingBag",
          value: "۸۹۲",
          label: "سفارشات امروز",
          gradient:
            "linear-gradient(135deg, rgb(46, 184, 170), rgb(38, 157, 217))",
        },
        {
          icon: "TrendingUp",
          value: "۴.۸٪",
          label: "نرخ تبدیل",
          gradient:
            "linear-gradient(135deg, rgb(249, 195, 31), rgb(235, 71, 99))",
        },
      ],
      templateCategories: [
        { id: "all", name: "همه قالب‌ها" },
        { id: "fashion", name: "مد و پوشاک" },
        { id: "electronics", name: "الکترونیک" },
        { id: "food", name: "غذا و نوشیدنی" },
        { id: "home", name: "خانه و دکوراسیون" },
        { id: "books", name: "کتاب و محصولات فرهنگی" },
      ],
      templates: [
        {
          name: "فروشگاه مد پارس",
          category: "fashion",
          categoryName: "مد و پوشاک",
          gradient: "linear-gradient(135deg, #eb4763, #a347d1)",
          rating: 5,
          isNew: true,
          isPopular: false,
          features: ["ریسپانسیو", "سئو شده", "۲۴ قالب"],
        },
        {
          name: "الکترو شاپ",
          category: "electronics",
          categoryName: "الکترونیک",
          gradient: "linear-gradient(135deg, #2eb8aa, #38a89d)",
          rating: 4,
          isNew: false,
          isPopular: true,
          features: ["ریسپانسیو", "سئو شده", "۱۲ قالب", "پشتیبانی از ویدیو"],
        },
        {
          name: "رستوران آنلاین",
          category: "food",
          categoryName: "غذا و نوشیدنی",
          gradient: "linear-gradient(135deg, #f9c31f, #eb4763)",
          rating: 5,
          isNew: true,
          isPopular: false,
          features: [
            "سیستم سفارش آنلاین",
            "مدیریت منو",
            "اتصال به درگاه",
            "پنل رستوران",
          ],
        },
        {
          name: "دکوراسیون مدرن",
          category: "home",
          categoryName: "خانه و دکوراسیون",
          gradient: "linear-gradient(135deg, #a347d1, #2eb8aa)",
          rating: 4,
          isNew: false,
          isPopular: false,
          features: ["گالری تصاویر", "فیلتر پیشرفته", "مشاوره آنلاین"],
        },
        {
          name: "کتابفروشی بوک‌لند",
          category: "books",
          categoryName: "کتاب و محصولات فرهنگی",
          gradient: "linear-gradient(135deg, #eb4763, #f9c31f)",
          rating: 5,
          isNew: true,
          isPopular: true,
          features: ["جستجوی پیشرفته", "نظرات کاربران", "پیشنهاد هوشمند"],
        },
        {
          name: "فروشگاه ورزشی",
          category: "fashion",
          categoryName: "مد و پوشاک",
          gradient: "linear-gradient(135deg, #2eb8aa, #eb4763)",
          rating: 4,
          isNew: false,
          isPopular: false,
          features: ["فیلتر سایز", "مقایسه محصولات", "ابعاد دقیق"],
        },
      ],
      pricingPlans: [
        {
          name: "شروع",
          description: "مناسب برای کسب‌وکارهای تازه‌کار",
          price: "رایگان",
          priceAnnual: "۲,۹۹۰",
          icon: "Rocket",
          gradient: "linear-gradient(135deg, #2eb8aa, #38a89d)",
          popular: false,
          features: [
            "۱ فروشگاه آنلاین",
            "تا ۱۰۰ محصول",
            "گزارش‌های پایه",
            "پشتیبانی ایمیل",
            "گواهی SSL رایگان",
            "۲ گیگابایت فضا",
            "دامنه زیرمجموعه",
          ],
          link: "https://panel.shopecom.ir",
        },
        {
          name: "حرفه‌ای",
          description: "مناسب برای کسب‌وکارهای در حال رشد",
          price: "۷۹۹",
          priceAnnual: "۷,۹۹۰",
          icon: "Briefcase",
          gradient: "linear-gradient(135deg, #eb4763, #a347d1)",
          popular: true,
          features: [
            "۳ فروشگاه آنلاین",
            "محصولات نامحدود",
            "گزارش‌های پیشرفته",
            "پشتیبانی اولویت‌دار ۲۴/۷",
            "گواهی SSL رایگان",
            "۱۰ گیگابایت فضا",
            "دامنه اختصاصی",
            "ابزارهای بازاریابی",
            "کوپن و تخفیف",
          ],
          link: "https://shopecom.ir",
        },
        {
          name: "تجاری",
          description: "مناسب برای شرکت‌های بزرگ",
          price: "۱,۴۹۰",
          priceAnnual: "۱۴,۹۰۰",
          icon: "Crown",
          gradient: "linear-gradient(135deg, #f9c31f, #eb4763)",
          popular: false,
          features: [
            "فروشگاه‌های نامحدود",
            "محصولات نامحدود",
            "گزارش‌های سازمانی",
            "پشتیبانی اختصاصی",
            "گواهی SSL پیشرفته",
            "فضای نامحدود",
            "دامنه‌های نامحدود",
            "مجموعه بازاریابی کامل",
            "دسترسی API",
            "حساب‌های تیمی (تا ۱۰ نفر)",
            "سرور اختصاصی",
          ],
          link: "https://shopecom.ir",
        },
      ],
      extraFeatures: [
        {
          icon: "CreditCard",
          text: "بدون کارت اعتباری",
          gradient: "linear-gradient(135deg, #eb4763, #a347d1)",
        },
        {
          icon: "HeadphonesIcon",
          text: "پشتیبانی ۲۴/۷",
          gradient: "linear-gradient(135deg, #2eb8aa, #38a89d)",
        },
        {
          icon: "Database",
          text: "پشتیبان‌گیری روزانه",
          gradient: "linear-gradient(135deg, #f9c31f, #eb4763)",
        },
        {
          icon: "BarChart",
          text: "آپدیت‌های رایگان",
          gradient: "linear-gradient(135deg, #a347d1, #2eb8aa)",
        },
      ],
      successStories: [
        {
          initial: "ل",
          title: "ممد کالا اسکل",
          revenue: "۱۲,۴۰۰تومان",
          gradient:
            "linear-gradient(135deg, rgb(235, 71, 99), rgb(245, 153, 61))",
          slug: "mmdkala",
        },
        {
          initial: "ز",
          title: "زیبایی ارگانیک",
          revenue: "۸,۹۰۰تومان",
          gradient:
            "linear-gradient(135deg, rgb(46, 184, 170), rgb(38, 157, 217))",
          slug: "organic-beauty",
        },
        {
          initial: "ت",
          title: "گجت‌های فناوری",
          revenue: "۲۳,۱۰۰تومان",
          gradient:
            "linear-gradient(135deg, rgb(163, 71, 209), rgb(221, 60, 167))",
          slug: "tech-gadgets",
        },
        {
          initial: "م",
          title: "مرکز مد",
          revenue: "۱۵,۶۰۰تومان",
          gradient:
            "linear-gradient(135deg, rgb(249, 195, 31), rgb(235, 71, 99))",
          slug: "fashion-hub",
        },
        {
          initial: "خ",
          title: "دکوراسیون خانه",
          revenue: "۹,۲۰۰تومان",
          gradient:
            "linear-gradient(135deg, rgb(60, 113, 221), rgb(46, 184, 170))",
          slug: "home-decor",
        },
        {
          initial: "و",
          title: "ورزشی",
          revenue: "۱۸,۳۰۰تومان",
          gradient:
            "linear-gradient(135deg, rgb(46, 184, 92), rgb(46, 184, 170))",
          slug: "sports-store",
        },
      ],
      testimonials: [
  {
    text: 'ایزانی واقعاً فروشگاه من رو متحول کرد. توی ۲ ماه از صفر به ۶۰ میلیون تومان فروش ماهانه رسیدم. پنل مدیریتش فوق‌العاده ساده‌ست و پشتیبانی‌شون همیشه بهموقع پاسخ میده.',
    name: "سارا محمدی",
    store: "بوتیک آنلاین رز",
    initial: "س",
  },
  {
    text: 'بهترین انتخاب برای راه‌اندازی فروشگاه اینترنتی. ابزارهای بازاریابی ایزانی به تنهایی مشتری‌های جدیدم رو سه برابر کرد. به هرکی می‌خواد جدی وارد فروش آنلاین بشه پیشنهادش می‌کنم.',
    name: "امیر حسینی",
    store: "گجت‌سنتر امیر",
    initial: "ا",
  },
  {
    text: 'فروشگاهم رو توی کمتر از ۲۰ دقیقه با ایزانی ساختم. قالب‌ها حرفه‌ای و شیک هستن و خرید از سایت خیلی روانه. بعد از انتقال به ایزانی، فروشم نزدیک ۵۰٪ بیشتر شد.',
    name: "مریم کریمی",
    store: "صنایع‌دستی کاشان",
    initial: "م",
  },
],
      blogPosts: [
        {
          category: "تجارت الکترونیک",
          title: "۱۰ نکته برای افزایش فروش فروشگاه آنلاین در سال ۲۰۲۴",
          excerpt:
            "استراتژی‌های اثبات شده برای افزایش درآمد تجارت الکترونیک و نرخ حفظ مشتری را کشف کنید.",
          date: "۱۵ دسامبر ۲۰۲۴",
          gradient:
            "linear-gradient(135deg, rgb(235, 71, 99), rgb(163, 71, 209))",
          slug: "10-tips-increase-online-sales-2024",
        },
        {
          category: "بازاریابی",
          title: "چگونه هویت برند قوی برای فروشگاه خود بسازیم",
          excerpt:
            "عناصر ضروری ساخت برند که فروشگاه‌های موفق را از رقبا متمایز می‌کند را بیاموزید.",
          date: "۱۰ دسامبر ۲۰۲۴",
          gradient:
            "linear-gradient(135deg, rgb(46, 184, 170), rgb(60, 113, 221))",
          slug: "build-strong-brand-identity",
        },
        {
          category: "سئو",
          title: "راهنمای کامل بهینه‌سازی سئو برای تجارت الکترونیک",
          excerpt:
            "تکنیک‌های بهینه‌سازی موتور جستجو که به طور خاص برای فروشگاه‌های آنلاین طراحی شده است را استاد شوید.",
          date: "۵ دسامبر ۲۰۲۴",
          gradient:
            "linear-gradient(135deg, rgb(249, 195, 31), rgb(244, 140, 37))",
          slug: "complete-ecommerce-seo-guide",
        },
      ],
      faqItems: [
        {
          icon: "Rocket",
          question: "چطور می‌توانم فروشگاه خود را راه‌اندازی کنم؟",
          answer:
            "راه‌اندازی فروشگاه در شاپیکام بسیار ساده است. پس از ثبت‌نام، با استفاده از سازنده کشیدن و رها کردن می‌توانید در کمتر از ۳۰ دقیقه فروشگاه خود را طراحی کنید. قالب‌های آماده، ابزارهای شخصی‌سازی و آموزش‌های گام‌به‌گام در تمام مراحل همراه شما هستند.",
          gradient: "linear-gradient(135deg, #eb4763, #a347d1)",
        },
        {
          icon: "CreditCard",
          question: "روش‌های پرداخت چه هستند؟",
          answer:
            "شاپیکام از تمام درگاه‌های پرداخت معتبر ایرانی شامل زرین‌پال، آیدی پی، پرداخت‌یار و ... پشتیبانی می‌کند. همچنین امکان اتصال به درگاه‌های بانکی مستقیم نیز وجود دارد. برای فروشگاه‌های بین‌المللی، PayPal و Stripe نیز قابل اتصال هستند.",
          gradient: "linear-gradient(135deg, #2eb8aa, #38a89d)",
        },
        {
          icon: "Shield",
          question: "امنیت فروشگاه چگونه تأمین می‌شود؟",
          answer:
            "تمامی فروشگاه‌ها به صورت خودکار گواهی SSL رایگان دریافت می‌کنند. اطلاعات مشتریان رمزنگاری شده، پشتیبان‌گیری روزانه انجام می‌شود و سیستم‌های ما ۲۴ ساعته توسط تیم امنیتی پایش می‌گردند. همچنین از پروتکل‌های امنیتی پیشرفته برای جلوگیری از نفوذ استفاده می‌کنیم.",
          gradient: "linear-gradient(135deg, #a347d1, #dd3ca7)",
        },
        {
          icon: "Globe",
          question: "آیا می‌توانم دامنه اختصاصی داشته باشم؟",
          answer:
            "بله، در تمام پلن‌های حرفه‌ای و تجاری می‌توانید دامنه اختصاصی خود را به فروشگاه متصل کنید. در پلن شروع، دامنه زیرمجموعه رایگان شاپیکام در اختیار شما قرار می‌گیرد. راهنمای کامل اتصال دامنه نیز در مستندات موجود است.",
          gradient: "linear-gradient(135deg, #f9c31f, #eb4763)",
        },
        {
          icon: "Users",
          question: "آیا محدودیت تعداد کارمندان داریم؟",
          answer:
            "در پلن شروع، تنها یک کاربر (مدیر فروشگاه) می‌توانید داشته باشید. پلن حرفه‌ای امکان اضافه کردن تا ۵ کاربر را می‌دهد و پلن تجاری تا ۱۰ کاربر با سطوح دسترسی مختلف را پشتیبانی می‌کند. امکان تعیین سطح دسترسی برای هر کاربر وجود دارد.",
          gradient: "linear-gradient(135deg, #eb4763, #f99b3d)",
        },
        {
          icon: "RefreshCw",
          question: "شرایط انصراف و بازگشت وجه چیست؟",
          answer:
            "شما می‌توانید تا ۱۴ روز پس از خرید هر پلن، در صورت عدم رضایت، انصراف خود را اعلام کنید و وجه پرداختی به طور کامل بازگردانده می‌شود. برای پلن‌های سالانه، امکان بازگشت وجه متناسب با ماه‌های باقی‌مانده وجود دارد.",
          gradient: "linear-gradient(135deg, #2eb8aa, #269dd9)",
        },
        {
          icon: "Settings",
          question: "آیا امکان نصب افزونه و قالب وجود دارد؟",
          answer:
            "بله، فروشگاه اپلیکیشن شاپیکام بیش از ۲۰۰ افزونه و قالب آماده دارد. می‌توانید از بین آن‌ها انتخاب کنید یا با استفاده از API اختصاصی، افزونه‌های سفارشی خود را توسعه دهید. تمامی افزونه‌ها و قالب‌ها تست شده و امنیت کامل دارند.",
          gradient: "linear-gradient(135deg, #a347d1, #893bb5)",
        },
        {
          icon: "Download",
          question: "آیا امکان انتقال داده‌ها از فروشگاه دیگر وجود دارد؟",
          answer:
            "بله، تیم ما ابزارهای مهاجرت خودکار برای ووکامرس، مجنتو، پرستاشاپ و سایر پلتفرم‌های محبوب ارائه می‌دهد. همچنین تیم پشتیبانی می‌تواند در فرآیند مهاجرت داده‌ها به شما کمک کند تا بدون دردسر فروشگاه خود را منتقل کنید.",
          gradient: "linear-gradient(135deg, #eb4763, #c13b53)",
        },
      ],
    };
  },
  computed: {
    filteredTemplates() {
      if (this.selectedTemplateCategory === "all") {
        return this.templates;
      }
      return this.templates.filter(
        (t) => t.category === this.selectedTemplateCategory
      );
    },
  },
  mounted() {
    // مقداردهی اولیه openFaqs
    this.openFaqs = new Array(this.faqItems.length).fill(false);

    const script = document.createElement("script");
    script.src = "https://cdn.gpteng.co/lovable.js";
    script.type = "module";
    script.onload = () => {
      this.initLovableBadge();
    };
    document.head.appendChild(script);
    this.initCountUpAnimation();
  },
  methods: {
    initLovableBadge() {
      setTimeout(() => {
        if (
          window.self !== window.top ||
          navigator.userAgent.includes("puppeteer")
        ) {
          const badge = document.getElementById("lovable-badge");
          if (badge) {
            badge.style.display = "none";
          }
        }

        const closeButton = document.getElementById("lovable-badge-close");
        if (closeButton) {
          closeButton.addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
            const badge = document.getElementById("lovable-badge");
            if (badge) {
              badge.classList.add("closing");
              setTimeout(() => {
                if (badge) {
                  badge.style.display = "none";
                }
              }, 240);
            }
          });
        }
      }, 100);
    },

    initCountUpAnimation() {
      const countElements = document.querySelectorAll(".count-up");

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const element = entry.target;
              const targetValue = parseFloat(
                element.getAttribute("data-value")
              );
              const suffix = element.innerText.includes("٪") ? "٪" : "";
              const prefix = element.innerText.includes("$") ? "$" : "";

              let startValue = 0;
              const duration = 2000;
              const increment = targetValue / (duration / 16);

              const timer = setInterval(() => {
                startValue += increment;
                if (startValue >= targetValue) {
                  element.innerText = prefix + targetValue + suffix;
                  clearInterval(timer);
                } else {
                  element.innerText = prefix + Math.floor(startValue) + suffix;
                }
              }, 16);

              observer.unobserve(element);
            }
          });
        },
        { threshold: 0.5 }
      );

      countElements.forEach((el) => observer.observe(el));
    },

    toggleFaq(index) {
      // روش صحیح برای Vue 3
      const newOpenFaqs = [...this.openFaqs];
      newOpenFaqs[index] = !newOpenFaqs[index];
      this.openFaqs = newOpenFaqs;
    },

    // انیمیشن برای باز شدن پاسخ
    onEnter(el) {
      el.style.height = "0";
      el.style.transition = "height 0.3s ease";
      setTimeout(() => {
        el.style.height = el.scrollHeight + "px";
      }, 10);
    },

    onLeave(el) {
      el.style.height = el.scrollHeight + "px";
      el.style.transition = "height 0.3s ease";
      setTimeout(() => {
        el.style.height = "0";
      }, 10);
    },
  },
};
</script>


<style scoped>
/* انیمیشن‌های سفارشی */
@keyframes float {
  0%,
  100% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-10px);
  }
}

@keyframes float-slow {
  0%,
  100% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-20px);
  }
}

@keyframes float-particle {
  0% {
    transform: translate(0, 0) scale(1);
    opacity: 0.2;
  }

  25% {
    transform: translate(20px, -20px) scale(1.5);
    opacity: 0.4;
  }

  50% {
    transform: translate(-10px, 15px) scale(0.8);
    opacity: 0.1;
  }

  75% {
    transform: translate(-25px, -10px) scale(1.2);
    opacity: 0.3;
  }

  100% {
    transform: translate(0, 0) scale(1);
    opacity: 0.2;
  }
}

@keyframes pulse-soft {
  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.7;
  }
}

@keyframes pulse-slow {
  0%,
  100% {
    opacity: 0.05;
  }

  50% {
    opacity: 0.1;
  }
}

@keyframes spin-slow {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes gradient-x {
  0%,
  100% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
}

@keyframes shimmer-wave {
  0% {
    transform: translateX(-100%) skewX(-15deg);
  }

  100% {
    transform: translateX(200%) skewX(-15deg);
  }
}

@keyframes grow-width {
  0% {
    width: 0%;
  }

  100% {
    width: var(--target-width, 75%);
  }
}

@keyframes grow-height {
  0% {
    height: 0%;
  }

  100% {
    height: var(--target-height, 100%);
  }
}

@keyframes fade-in-up {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fade-in-left {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fade-in-right {
  from {
    opacity: 0;
    transform: translateX(20px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* کلاس‌های انیمیشن */
.animate-float {
  animation: float 3s ease-in-out infinite;
}

.animate-float-slow {
  animation: float-slow 6s ease-in-out infinite;
}

.animate-float-particle {
  animation: float-particle 8s ease-in-out infinite;
}

.animate-pulse-soft {
  animation: pulse-soft 2s ease-in-out infinite;
}

.animate-pulse-slow {
  animation: pulse-slow 4s ease-in-out infinite;
}

.animate-spin-slow {
  animation: spin-slow 3s linear infinite;
}

.animate-gradient-x {
  background-size: 200% 200%;
  animation: gradient-x 3s ease infinite;
}

.animate-shimmer {
  animation: shimmer 2s infinite;
}

.animate-shimmer-wave {
  animation: shimmer-wave 3s ease-in-out infinite;
}

.animate-grow-width {
  animation: grow-width 1s ease-out forwards;
}

.animate-grow-height {
  animation: grow-height 1s ease-out forwards;
}

.animate-fade-in-up {
  animation: fade-in-up 0.6s ease-out forwards;
  opacity: 0;
}

.animate-fade-in-left {
  animation: fade-in-left 0.6s ease-out forwards;
  opacity: 0;
}

.animate-fade-in-right {
  animation: fade-in-right 0.6s ease-out forwards;
  opacity: 0;
}

/* تاخیرهای انیمیشن */
.animation-delay-100 {
  animation-delay: 100ms;
}

.animation-delay-200 {
  animation-delay: 200ms;
}

.animation-delay-300 {
  animation-delay: 300ms;
}

.animation-delay-400 {
  animation-delay: 400ms;
}

.animation-delay-500 {
  animation-delay: 500ms;
}

.animation-delay-600 {
  animation-delay: 600ms;
}

.animation-delay-700 {
  animation-delay: 700ms;
}

.animation-delay-800 {
  animation-delay: 800ms;
}

.animation-delay-900 {
  animation-delay: 900ms;
}

.animation-delay-1000 {
  animation-delay: 1000ms;
}

.animation-delay-1100 {
  animation-delay: 1100ms;
}

.animation-delay-2000 {
  animation-delay: 2000ms;
}

.animation-delay-3000 {
  animation-delay: 3000ms;
}

/* استایل‌های اضافی */
.backdrop-blur-sm {
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.glass {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.count-up {
  display: inline-block;
}

/* انیمیشن برای پاسخ FAQ */
.faq-enter-active,
.faq-leave-active {
  transition: all 0.3s ease;
  max-height: 200px;
}

.faq-enter,
.faq-leave-to {
  opacity: 0;
  max-height: 0;
  margin-top: 0;
  padding-top: 0;
}

/* انیمیشن چرخش آیکون */
.rotate-180 {
  transform: rotate(180deg);
}

/* استایل برای پاسخ */
.answer-text {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  transition: all 0.3s ease;
}

.answer-text.expanded {
  -webkit-line-clamp: unset;
}

/* انیمیشن برای آیکون‌ها */
.icon-pulse {
  animation: icon-pulse 2s ease-in-out infinite;
}

@keyframes icon-pulse {
  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }
}
</style>